import { createAction } from 'redux-actions';
import {
  TIMELINE_REQUEST,
  TIMELINE_SUCCESS,
  TIMELINE_FAILURE,
  TIMELINE_REQUEST_FUTURE,
  TIMELINE_SUCCESS_FUTURE,
  TIMELINE_FAILURE_FUTURE,
  TIMELINE_REQUEST_PAST,
  TIMELINE_SUCCESS_PAST,
  TIMELINE_FAILURE_PAST,
} from './constants';

export const fetchTimeline = createAction(TIMELINE_REQUEST);
export const TimelineSuccess = createAction(TIMELINE_SUCCESS);
export const TimelineFailure = createAction(TIMELINE_FAILURE);

export const fetchTimelineFuture = createAction(TIMELINE_REQUEST_FUTURE);
export const TimelineFutureSuccess = createAction(TIMELINE_SUCCESS_FUTURE);
export const TimelineFutureFailure = createAction(TIMELINE_FAILURE_FUTURE);

export const fetchTimelinePast = createAction(TIMELINE_REQUEST_PAST);
export const TimelinePastSuccess = createAction(TIMELINE_SUCCESS_PAST);
export const TimelinePastFailure = createAction(TIMELINE_FAILURE_PAST);
